export function WebSecurityCo() {
    const courses = [
      { 
        title: "HTML and CSS in depth (From CiCdCo)", 
        url: "https://www.coursera.org/learn/html-and-css-in-depth"
      },
      { 
        title: "HTML for Beginners: Getting Started (Project Network)", 
        url: "https://www.coursera.org/projects/html-for-beginners-getting-started"
      },
      { 
        title: "Introduction to HTML (Project Network)", 
        url: "https://www.coursera.org/projects/introduction-to-html"
      },
      { 
        title: "HTML & CSS Crash Course (From Scrimba)", 
        url: "https://www.coursera.org/learn/html--css-crash-course"
      },
      { 
        title: "Build a Webpage with HTML and CSS (BOORD infinity)", 
        url: "https://www.coursera.org/learn/build-a-webpage-with-html-and-css"
      }
    ];
  
    return (
      <>
        <h1>Top 5 Recommended Coursera Courses with Certifications</h1>
        <h4>
          1. Dive Into The Main Concepts <br />
          2. Animation Explanations with Real-World Examples <br />
          3. Important Notes and Clarifications
        </h4>
  
        {courses.map((course, index) => (
          <div key={index}>
            <p>{index + 1}. {course.title}
              <button 
                style={{ padding: '7px', background: 'black', color: 'white', borderRadius: '8px' }}
                onClick={() => window.open(course.url, "_blank")}
              >
                Click Me
              </button>
            </p>
          </div>
        ))}
      </>
    );
  }
  
  export default WebSecurityCo;
  